<template>
  <label class="checkbox-radio" :class="{active: id === value}">
    <div class="items">
      <slot></slot>
      <input type="radio" :value="value" :checked="value === id" @change="$emit('input', id)" />
    </div>
  </label>
</template>
<script>
export default {
  name: 'RadioGroup',
  components: {},
  props: ['value', 'id'],
}
</script>



